import React, { Component } from "react";
import { connect } from "react-redux";
import IdleTimer from "react-idle-timer";

import { handleModalState } from "common-components/Modal/actions/handleModalState";

import API,{ setBaseURLForNonSecure } from "../../../Services/API";

import { ENDPOINTS } from "utils/endpoints";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

import InactivityModal from "./Modals/InactivityModal";
import LoggedOutModal from "./Modals/LoggedOutModal";

class Timeout extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.logoutTimerId = null;

    this.state = {
      warningTimer: window.reactGlobals.session.warningTimer,
      logoutTimer: window.reactGlobals.session.logoutTimer,
      vilsTimer: window.reactGlobals.session.warningTimer,
      isInactivityModalOpen: false,
      isLoggedOutModalOpen: false,
      isNonSecureUser: false,
      section_title: "Are you still there?",
      section_description: "Due to inactivity, your session will end in approximately:",
      buttonContent: "Extend my session"
    };
  }

  async componentDidMount() {
    if (
      window.location.pathname === "/privacy/your-data" ||
      window.location.pathname === "/privacy/your-data/" ||
      window.location.pathname === "/privacy/your-data/login"
    ) {
      return this.idleTimer.pause();
    }

    if (checkAMLob() === "vils") {
      setInterval(() => {
        this.setState(() => ({
          vilsTimer: this.state.vilsTimer - 1
        }));
      }, 1000);
    }

    try {

      if (window.location.pathname.indexOf("/secure/") === -1) {
        setBaseURLForNonSecure();        
      }
  
      const response = await API({
        method: "POST",
        url: ENDPOINTS.FETCH_TIMEOUT_PAGE
      });

      if (response && response.data) {
        if (typeof response.data === "string") {
          const res = JSON.parse(response.data);

          if (checkNestedObject(res, "sections", [0], "timeout", "buttons", [0], "text")) {
            const {
              sections: [
                {
                  timeout: { section_title, section_description, buttons }
                }
              ]
            } = res;

            this.setState({
              section_title,
              section_description,
              buttonContent: buttons[0].text
            });
          }
        }
      }
    } catch (error) {}

    if (window.location.pathname.indexOf("/secure/") === -1) {
      this.setState({ isNonSecureUser: true });
      // this.idleTimer.pause();
    }
  }

  closeModal = () => {
    this.setState({
      isInactivityModalOpen: false,
      isLoggedOutModalOpen: false,
      logoutTimer: window.reactGlobals.session.logoutTimer,
      vilsTimer: window.reactGlobals.session.warningTimer
    });
    this.idleTimer.reset();
    clearInterval(this.logoutTimerId);
    this.logoutTimerId = null;
  };

  renewSession = async () => {
    try {
      const response = await API({
        method: "POST",
        url: ENDPOINTS.RENEW_USER_SESSION
      });

      if (response && response.status === "OK") {
        this.closeModal();
      }
    } catch (error) {
      window.location.href = "/privacy/your-data";
    }
  };

  renderModal = () => {
    if (this.state.isInactivityModalOpen) {
      return (
        <InactivityModal
          logoutTimer={this.state.logoutTimer}
          isInactivityModalOpen={this.state.isInactivityModalOpen}
          renewSession={this.renewSession}
          section_title={this.state.section_title}
          section_description={this.state.section_description}
          buttonContent={this.state.buttonContent}
        />
      );
    } else if (this.state.isLoggedOutModalOpen) {
      return (
        <LoggedOutModal
          isLoggedOutModalOpen={this.state.isLoggedOutModalOpen}
          isNonSecureUser={this.state.isNonSecureUser}
        />
      );
    }
    return null;
  };

  onIdle = () => {
    this.idleTimer.pause();
    if (!this.logoutTimerId) {
      this.props.handleModalState(false);
      this.setState({ isInactivityModalOpen: true });
      this.logoutTimerId = setInterval(() => {
        this.setState(() => ({ logoutTimer: this.state.logoutTimer - 1 }));
        if (this.state.logoutTimer === 0) {
          // this.props.handleModalState(false);
          // this.setState({
          //   isInactivityModalOpen: false,
          //   isLoggedOutModalOpen: true,
          //   logoutTimer: 4
          // });
          clearInterval(this.logoutTimerId);

          if (this.state.isNonSecureUser) {
            return (window.location.href = "/privacy/your-data");
          }
          return (window.location.href = ENDPOINTS.LOGOUT);
        }
      }, 1000);
    }
  };

  handleOnAction = () => {
    if (checkAMLob() === "vils" && !this.state.isInactivityModalOpen) {
      const { vilsTimer } = this.state;

      if (vilsTimer < 60) {
        this.renewSession();
        this.setState({ vilsTimer: window.reactGlobals.session.warningTimer });
      }
    }
  };

  render() {
    return (
      <div>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          onIdle={this.onIdle}
          onAction={this.handleOnAction}
          timeout={this.state.warningTimer * 1000}
          throttle={500}
        />
        {this.renderModal()}
      </div>
    );
  }
}

export default connect(
  null,
  { handleModalState }
)(Timeout);
